<template>
  <section id="faq" class="section-padding bg-gray-50 dark:bg-dark-surface">
    <div class="container-custom">
      <!-- Section Header -->
      <div class="text-center mb-16">
        <h2
          class="text-4xl md:text-5xl font-display font-bold text-gray-900 dark:text-white mb-4"
        >
          Frequently Asked Questions
        </h2>
        <p class="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
          Quick answers to common questions about our services, process, and
          pricing.
        </p>
      </div>

      <!-- FAQ Preview Grid -->
      <div class="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto mb-12">
        <div
          v-for="faq in previewFaqs"
          :key="faq.id"
          class="bg-white dark:bg-dark-bg rounded-xl p-6 border border-gray-200 dark:border-dark-border hover:border-primary dark:hover:border-accent transition-all duration-300 hover:shadow-lg"
        >
          <div class="flex items-start space-x-4">
            <div
              class="flex-shrink-0 w-10 h-10 rounded-full bg-primary/10 dark:bg-accent/10 flex items-center justify-center"
            >
              <HelpCircle class="text-primary dark:text-accent" :size="20" />
            </div>
            <div class="flex-1">
              <h3
                class="text-lg font-display font-semibold text-gray-900 dark:text-white mb-2"
              >
                {{ faq.question }}
              </h3>
              <p
                class="text-gray-600 dark:text-gray-300 text-base leading-relaxed"
              >
                {{ faq.answer }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- View All Button -->
      <div class="text-center">
        <router-link
          to="/faq"
          class="inline-flex items-center space-x-2 btn-primary text-lg px-8 py-4"
        >
          <span>View All FAQs</span>
          <ArrowRight :size="20" />
        </router-link>
        <p class="mt-4 text-sm text-gray-600 dark:text-gray-400">
          Browse all questions across 3 categories
        </p>
      </div>
    </div>
  </section>
</template>

<script setup>
import { HelpCircle, ArrowRight } from "lucide-vue-next";

const previewFaqs = [
  {
    id: 1,
    question: "What services do you offer?",
    answer: "Web development, mobile apps, and AI automation solutions.",
  },
  {
    id: 2,
    question: "How long does a project take?",
    answer:
      "Depends on the requirements. It can take from 1 month to 6 months.",
  },
  {
    id: 3,
    question: "What does a project cost?",
    answer:
      "Depends on the size and complexity of the project. It can range from basic $100 to $2,000 project to big $5,000 to $10,000 project.",
  },
  {
    id: 4,
    question: "Who owns the code?",
    answer: "You own everything upon full payment.",
  },
];
</script>

<style scoped>
.section-padding {
  @apply py-20 md:py-28;
}
</style>
